const addressingRules = {
    "/^[1-9]$|^[1-9][0-9]$|^[1-4][0-9][0-9]$|^50[0-9]$|^51[0-2]$/": {
        comment: "1 through 9 or 10 through 99 or 100 through 499 or 500 through 509 or 510 through 512. (Basically 1 through 512)",
        getAddress: idx => (idx + 1).toString(),
        maxIndex: 511,
    },
    "/^[a-fA-F0-9]{2}-[a-fA-F0-9]{2}-[a-fA-F0-9]{2}-[a-fA-F0-9]{2}-[a-fA-F0-9]{2}$/": {
        comment: "AA-AA-AA-AA-00 through AA-AA-AA-AA-0D",
        getAddress: idx => "AA-AA-AA-AA-" + idx.toString(16).toUpperCase().padStart(2, "0"),
        maxIndex: 13
    },
    "/^1[0-6]$|^[1-9]$/": {
        comment: "1 through 16",
        getAddress: idx => (idx + 1).toString(),
        maxIndex: 15,
    },
    "/^[1-4]$/": {
        comment: "1 through 4",
        getAddress: idx => (idx + 1).toString(),
        maxIndex: 3,
    },
    "/^(?:[1-9]|[1-9][0-9]|1\\d\\d|2[0-3]\\d|24[0-7])$/": {
        comment: "1 through 247",
        getAddress: idx => (idx + 1).toString(),
        maxIndex: 246,
    },
    "/^[a-fA-F0-9]{2}-[a-fA-F0-9]{2}-[a-fA-F0-9]{2}-[a-fA-F0-9]{2}-[a-fA-F0-9]{2}-[a-fA-F0-9]{2}$/": {
        comment: "AA-AA-AA-AA-AA-00 through AA-AA-AA-AA-AA-0D",
        getAddress: idx => "AA-AA-AA-AA-AA-" + idx.toString(16).toUpperCase().padStart(2, "0"),
        maxIndex: 13,
    },
    "/^[1-3]$/": {
        comment: "1 through 3",
        getAddress: idx => (idx + 1).toString(),
        maxIndex: 2,
    },
    "/^[1-4]$|^[a-zA-Z0-9 ]{13,}$/": {
        comment: "1 through 4",
        getAddress: idx => (idx + 1).toString(),
        maxIndex: 3,
    },
    "/^(3[0-2]|[1-2]?[0-9])$/": {
        comment: "1 through 32",
        getAddress: idx => (idx + 1).toString(),
        maxIndex: 31,
    },
    "/^(160|16[1-9]|17[0-9]|18[0-9]|190)$/": {
        comment: "160 through 190",
        getAddress: idx => (160 + idx).toString(),
        maxIndex: 30,
    },
    "/^BYEF\\d{14}$/": {
        comment: "BYEF12345678901201 through BYEF12345678901216",
        getAddress: idx => "BYEF123456789012" + (idx + 1).toString().padStart(2, "0"),
        maxIndex: 15,
    },
    "/^(1[0-6]|[1-9])$/": {
        comment: "1 through 16",
        getAddress: idx => (idx + 1).toString(),
        maxIndex: 15,
    },
};

export default addressingRules;
